module.exports = __webpack_public_path__ + "static/media/praieiro.434efcda.jpg";